// extracted by mini-css-extract-plugin
export default {"overlay":"xD-z","bodyOpen":"yD-z","content":"zD-z","header":"AD-z","close":"BD-z","closeNoHeading":"CD-z"};